import CookieCategories from './cookie-categories'

export default CookieCategories

export * from './cookie-categories'
